import React from 'react';
import { motion } from 'framer-motion';
import { Container } from './ui/Container';
import { Button } from './ui/Button';
export function ProblemAwarenessSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-24 bg-white" data-id="element-295">
      <Container data-id="element-296">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="max-w-3xl mx-auto" data-id="element-297">
          <div className="text-center mb-12" data-id="element-298">
            <h2 className="text-sm font-bold tracking-widest text-gray-400 uppercase mb-4" data-id="element-299">
              The Private Pain
            </h2>
            <h3 className="text-3xl md:text-4xl font-serif text-gray-900 leading-tight" data-id="element-300">
              Nobody really warns you what snoring turns into after enough
              years.
            </h3>
          </div>

          <div className="space-y-6 text-lg text-gray-600 leading-relaxed font-light" data-id="element-301">
            <p data-id="element-302">Not just the noise.</p>
            <p data-id="element-303">Everything around it.</p>
            <p data-id="element-304">Waiting for him to fall asleep first.</p>
            <p data-id="element-305">
              The quiet frustration at 2 in the morning when the snoring starts
              again.
            </p>
            <p data-id="element-306">The way you start calculating sleep before bed even happens.</p>

            <p className="text-2xl font-serif text-gray-800 italic py-4 border-l-2 border-blue-100 pl-6 my-8" data-id="element-307">
              The separate blankets.
              <br data-id="element-308" />
              The couch nights.
              <br data-id="element-309" />
              The vacations where you secretly worry about hotel walls being too
              thin.
            </p>

            <p data-id="element-310">
              The exhaustion the next morning when he asks: “Was I really
              snoring that much?”
            </p>
            <p data-id="element-311">And you say: “It is okay.”</p>
            <p data-id="element-312">Even when it is not.</p>
            <p data-id="element-313">
              Because after enough nights of interrupted sleep, irritation turns
              into routine.
            </p>
            <p data-id="element-314">You stop expecting rest.</p>
            <p data-id="element-315">You start adapting around exhaustion instead.</p>

            <div className="bg-[#FDFBF7] p-8 rounded-2xl my-8 space-y-4" data-id="element-316">
              <p data-id="element-317">Extra coffee.</p>
              <p data-id="element-318">Earlier bedtimes.</p>
              <p data-id="element-319">Pretending you are not frustrated.</p>
              <p data-id="element-320">Pretending it has not changed the relationship.</p>
            </div>

            <p className="text-xl text-gray-800 font-medium pt-4" data-id="element-321">
              And maybe the saddest part is how normal it starts to feel.
            </p>
            <p data-id="element-322">Two people sleeping in separate rooms.</p>
            <p data-id="element-323">Not because they want to.</p>
            <p data-id="element-324">Because they are tired.</p>
          </div>

          <div className="mt-16 text-center" data-id="element-325">
            <Button onClick={scrollToPricing} variant="outline" size="lg" className="px-8" data-id="element-326">
              See Why Couples Are Switching
            </Button>
          </div>
        </motion.div>
      </Container>
    </section>;
}